import { useEffect, useState } from 'react';
import { getStoreStatus } from './api';

let cache = null;
let cacheAt = 0;
let inflight = null;

/** Estado abierto/cerrado compartido entre header, menú y checkout (una petición por minuto). */
export function useStoreStatus() {
  const [status, setStatus] = useState(cache);
  useEffect(() => {
    let alive = true;
    const fresh = cache && Date.now() - cacheAt < 60000;
    if (fresh) {
      setStatus(cache);
      return undefined;
    }
    if (!inflight) {
      inflight = getStoreStatus()
        .then((s) => {
          cache = s;
          cacheAt = Date.now();
          return s;
        })
        .catch(() => null)
        .finally(() => {
          inflight = null;
        });
    }
    inflight.then((s) => {
      if (alive && s) setStatus(s);
    });
    return () => {
      alive = false;
    };
  }, []);
  return status;
}
